/**
 * @author：
 * @update：
 * @description：
 **/

import { mealType } from "@/utils/enum";

import CusPagination from "@/components/cusPagination.vue";
import axios from "axios";
import { imageOrdersList, imageExport } from "@/api/package";
import { fileEcho, shopDetail } from "@/api/url";
import { requestUrl } from "../../../config/config";
export default {
  components: {
    CusPagination,
  },
  data() {
    return {
      mealType,
      loading: true,
      searchForm: {
        orderNo: "",
        goodsName: "",
        goodsUnionld: "",
        storeName: "",
        name: "",
        buyerName: "",
        deliveryMode: "",
        state: "",
        createdDate: "",
      },
      stateText: "",
      tableData: [],
      tableDataLoc: fileEcho,
      tabsCut: 0, //页头切换
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  // 自定义方法
  methods: {
    //搜索
    seachBtn() {
      console.log(this.searchForm);
      this.getList();
    },
    //重置
    resetBtn() {
      this.searchForm.orderNo = "";
      this.searchForm.goodsName = "";
      this.searchForm.goodsUnionld = "";
      this.searchForm.storeName = "";
      this.searchForm.name = "";
      this.searchForm.buyerName = "";
      this.searchForm.deliveryMode = "";
      this.searchForm.state = "";
      this.searchForm.createdDate = "";
      this.cutCreatedDate = "";
      this.getList();
    },
    //获取数据
    getList() {
      if (this.searchForm.createdDate.length > 0) {
        this.cutCreatedDate =
          this.searchForm.createdDate[0] + "," + this.searchForm.createdDate[1];
      }
      this.loading = true;
      this.$ajax
        .get(imageOrdersList, {
          code: this.searchForm.orderNo,
          goodsName: this.searchForm.goodsName,
          id: this.searchForm.goodsUnionld,
          phone: this.searchForm.name,
          shopName: this.searchForm.storeName,
          // buyerName: this.searchForm.buyerName,
          // deliveryMode: this.searchForm.deliveryMode,
          type: this.searchForm.state,
          beginTime: this.cutCreatedDate
            ? this.cutCreatedDate.split(",")[0] + " 00:00:00"
            : "",
          endTime: this.cutCreatedDate
            ? this.cutCreatedDate.split(",")[1] + " 23:59:59"
            : "",
          // createdDate: this.cutCreatedDate,
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          status: this.tabsCut == 4 ? 0 : this.tabsCut || "",

          ids: this.$route.query.userId,
        })
        .then(
          (res) => {
            if (res.data.code == 200) {
              // 成功了
              this.tableData = res.data.data.records;
              this.total = res.data.data.total;
              this.loading = false;
            }
          },
          (err) => {
            console.log(err);
            this.loading = false;
          }
        );
    },
    cut(num) {
      console.log(num);
      if (num == 0) {
        this.tabsCut = 0;
        this.stateText = "";
        this.getList();
      } else if (num == 1) {
        this.tabsCut = 1;
        this.stateText = "TOPAY";
        this.getList();
      } else if (num == 2) {
        this.tabsCut = 2;
        this.stateText = "TOSHIP";
        this.getList();
      } else if (num == 3) {
        this.tabsCut = 3;
        this.stateText = "SHIPPED";
        this.getList();
      } else if (num == 4) {
        this.tabsCut = 4;
        this.stateText = "CONFIRMED";
        this.getList();
      } else if (num == 5) {
        this.tabsCut = 5;
        this.stateText = "CANCELED";
        this.getList();
      } else if (num == 6) {
        this.tabsCut = 6;
        this.stateText = "AUDITING";
        this.getList();
      }
    },
    detailsBtn(item) {
      let id = window.btoa(item.id);
      this.$router.push({
        path: "/imageOrderDetail",
        query: { id: id, code: item.code },
      });
    },
    exportBtn() {
      const params = {
        code: this.searchForm.orderNo,
        goodsName: this.searchForm.goodsName,
        id: this.searchForm.goodsUnionld,
        phone: this.searchForm.name,
        shopName: this.searchForm.storeName,
        type: this.searchForm.state,
        beginTime: this.cutCreatedDate
          ? this.cutCreatedDate.split(",")[0] + " 00:00:00"
          : "",
        endTime: this.cutCreatedDate
          ? this.cutCreatedDate.split(",")[1] + " 23:59:59"
          : "",
        status: this.tabsCut || "",
      };
      axios({
        url: requestUrl + imageExport,
        method: "get",
        params: params,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }).then((res) => {
        if (!res) return;
        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel,charset=utf-8",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "图片下载.xlsx";
        a.click();
        URL.revokeObjectURL(url);
      });
    },
  },
  // 数据观察监听
  watch: {
    currentPage(newData, oldData) {
      this.getList();
    },
    pageSize(newData, oldData) {
      this.getList();
    },
  },
  // 计算数据
  computed: {},
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {
    if (this.$route.query.shopId != undefined) {
      this.$ajax
        .get(shopDetail(this.$route.query.shopId), {
          id: this.$route.query.shopId,
        })
        .then(
          (res) => {
            console.log(res);
            this.searchForm.storeName = res.data.name;
            if (this.$route.query.type != undefined) {
              if (this.$route.query.type == "") {
                this.tabsCut = 0;
                this.stateText = "";
                this.getList();
              } else if (this.$route.query.type == "TOPAY") {
                this.tabsCut = 1;
                this.stateText = "TOPAY";
                this.getList();
              } else if (this.$route.query.type == "TOSHIP") {
                this.tabsCut = 2;
                this.stateText = "TOSHIP";
                this.getList();
              } else if (this.$route.query.type == "SHIPPED") {
                this.tabsCut = 3;
                this.stateText = "SHIPPED";
                this.getList();
              } else if (this.$route.query.type == "CONFIRMED") {
                this.tabsCut = 4;
                this.stateText = "CONFIRMED";
                this.getList();
              } else if (this.$route.query.type == "CANCELED") {
                this.tabsCut = 5;
                this.stateText = "CANCELED";
                this.getList();
              } else if (this.$route.query.type == "AUDITING") {
                this.tabsCut = 6;
                this.stateText = "AUDITING";
                this.getList();
              }
            }
            this.getList();
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.getList();
    }
  },
  // 组件挂载完成之前
  beforeMount() {},
  // 组件挂载完成
  mounted() {},
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {},
};
